import { __values } from "tslib";
import { __extends, __decorate, __assign } from 'tslib';
window.__extends = __extends;
window.__decorate = __decorate;
window.__assign = __assign;
/**
 * @public
 */
var DoubleClick = /** @class */ (function () {
    function DoubleClick(timeout) {
        if (timeout === void 0) { timeout = 300; }
        this.timeout = timeout;
        this.clicked = false;
        this.timer = null;
    }
    DoubleClick.prototype.onclick = function (singleClick) {
        var _this = this;
        if (!this.clicked) {
            this.clicked = true;
            singleClick();
            this.timer = setTimeout(function () {
                _this.clicked = false;
            }, this.timeout);
        }
        else {
            this.clicked = false;
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
        }
    };
    return DoubleClick;
}());
export { DoubleClick };
/**
 * @public
 */
export function getContainerClassName(noDots) {
    if (noDots === void 0) { noDots = undefined; }
    var values = ['tree-container-ul', 'tree-children'];
    if (noDots) {
        values.push('tree-no-dots');
    }
    return values.join(' ');
}
/**
 * @public
 */
export function getNodeClassName(data, last, hasChildren) {
    if (hasChildren === void 0) { hasChildren = false; }
    var values = ['tree-node'];
    if (data.state.openable || data.children.length > 0 || hasChildren) {
        if (data.state.opened) {
            values.push('tree-open');
        }
        else {
            values.push('tree-closed');
        }
        if (data.state.loading) {
            values.push('tree-loading');
        }
    }
    else {
        values.push('tree-leaf');
    }
    if (last) {
        values.push('tree-last');
    }
    return values.join(' ');
}
/**
 * @public
 */
export function getAnchorClassName(data, hovered, path) {
    var values = ['tree-anchor', 'tree-relative', "tree-anchor-" + path.join('-')];
    if (data.state.selected) {
        values.push('tree-clicked');
    }
    if (data.state.disabled) {
        values.push('tree-disabled');
    }
    if (data.state.highlighted) {
        values.push('tree-search');
    }
    if (hovered) {
        values.push('tree-hovered');
    }
    return values.join(' ');
}
/**
 * @public
 */
export function getCheckboxClassName(data, path) {
    var values = ['tree-icon', 'tree-checkbox', "tree-checkbox-" + path.join('-')];
    if (data.children
        && data.children.some(function (child) { return child.state.selected; })
        && data.children.some(function (child) { return !child.state.selected; })) {
        values.push('tree-undetermined');
    }
    return values.join(' ');
}
/**
 * @public
 */
export function getRootClassName(checkbox, size, theme) {
    if (checkbox === void 0) { checkbox = undefined; }
    if (theme === void 0) { theme = 'default'; }
    var values = ['tree'];
    if (size) {
        values.push("tree-" + theme + "-" + size);
    }
    else {
        values.push("tree-" + theme);
    }
    if (checkbox) {
        values.push('tree-checkbox-selection', 'tree-checkbox-no-clicked');
    }
    return values.join(' ');
}
/**
 * @public
 */
export function getIconClassName(icon) {
    var values = ['tree-icon', 'tree-themeicon'];
    if (icon) {
        values.push('tree-themeicon-custom', icon);
    }
    return values.join(' ');
}
/**
 * @public
 */
export function getOclClassName(path) {
    return ['tree-icon', 'tree-ocl', "tree-ocl-" + path.join('-')].join(' ');
}
/**
 * @public
 */
export function getMarkerClassName(data) {
    var values = ["tree-marker-" + data.state.dropPosition];
    if (data.state.dropAllowed) {
        values.push('allowed');
    }
    else {
        values.push('not-allowed');
    }
    return values.join(' ');
}
/**
 * @public
 */
export function getNodeFromPath(rootData, path) {
    var e_1, _a;
    var node = null;
    try {
        for (var path_1 = __values(path), path_1_1 = path_1.next(); !path_1_1.done; path_1_1 = path_1.next()) {
            var index = path_1_1.value;
            node = node ? node.children[index] : rootData[index];
            if (!node) {
                return null;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (path_1_1 && !path_1_1.done && (_a = path_1.return)) _a.call(path_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return node;
}
function getGlobalOffset(dropTarget) {
    var offset = 0;
    var currentElem = dropTarget;
    while (currentElem) {
        offset += (currentElem.offsetTop - currentElem.scrollTop);
        currentElem = currentElem.offsetParent;
    }
    return offset;
}
function getDropPosition(pageY, offsetTop, offsetHeight) {
    var top = pageY - offsetTop;
    if (top < offsetHeight / 3) {
        return 1 /* up */;
    }
    else if (top > offsetHeight * 2 / 3) {
        return 3 /* down */;
    }
    else {
        return 2 /* inside */;
    }
}
function clearDropPositionOfTree(tree) {
    var e_2, _a;
    if (tree.state.dropPosition) {
        tree.state.dropPosition = 0 /* empty */;
    }
    if (tree.children) {
        try {
            for (var _b = __values(tree.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                clearDropPositionOfTree(child);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
}
/**
 * @public
 */
export function ondrag(pageY, dragTarget, dropTarget, dragTargetRoot, dropTargetRoot, dropAllowed, next) {
    if (dropTarget && dragTarget) {
        var sourcePath = dragTarget.dataset.path.split(',').map(function (s) { return +s; });
        var dropTargetPathString = dropTarget.dataset.path;
        if (dropTargetPathString) {
            var targetPath = dropTargetPathString.split(',').map(function (s) { return +s; });
            var targetData = getNodeFromPath(dropTargetRoot, targetPath);
            var sourceData = getNodeFromPath(dragTargetRoot, sourcePath);
            if (!targetData || !sourceData) {
                return;
            }
            var offsetTop = getGlobalOffset(dropTarget);
            var position = getDropPosition(pageY, offsetTop, dropTarget.offsetHeight);
            if (targetData.state.dropPosition !== position) {
                targetData.state.dropPosition = position;
                var dropData = {
                    sourcePath: sourcePath,
                    targetPath: targetPath,
                    sourceData: sourceData,
                    targetData: targetData,
                    sourceRoot: dragTargetRoot
                };
                targetData.state.dropAllowed = dropAllowed ? dropAllowed(dropData) : true;
                if (next) {
                    next();
                }
            }
        }
    }
}
/**
 * @public
 */
export function ondragleave(target, data) {
    var pathString = target.dataset.path;
    if (pathString) {
        var path = pathString.split(',').map(function (s) { return +s; });
        var node = getNodeFromPath(data, path);
        if (node && node.state.dropPosition !== 0 /* empty */) {
            node.state.dropPosition = 0 /* empty */;
        }
    }
}
/**
 * @public
 */
export function ondrop(target, dragTarget, dragTargetRoot, dropTargetRoot, next) {
    var e_3, _a;
    if (dragTarget) {
        var sourcePath = dragTarget.dataset.path.split(',').map(function (s) { return +s; });
        var targetPathString = target.dataset.path;
        if (targetPathString) {
            var targetPath = targetPathString.split(',').map(function (s) { return +s; });
            var targetData = getNodeFromPath(dropTargetRoot, targetPath);
            var sourceData = getNodeFromPath(dragTargetRoot, sourcePath);
            if (!targetData || !sourceData) {
                return;
            }
            if (targetData.state.dropPosition !== 0 /* empty */) {
                var dropData = {
                    sourcePath: sourcePath,
                    targetPath: targetPath,
                    sourceData: sourceData,
                    targetData: targetData,
                    sourceRoot: dragTargetRoot
                };
                next(dropData);
            }
        }
    }
    try {
        for (var dropTargetRoot_1 = __values(dropTargetRoot), dropTargetRoot_1_1 = dropTargetRoot_1.next(); !dropTargetRoot_1_1.done; dropTargetRoot_1_1 = dropTargetRoot_1.next()) {
            var node = dropTargetRoot_1_1.value;
            clearDropPositionOfTree(node);
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (dropTargetRoot_1_1 && !dropTargetRoot_1_1.done && (_a = dropTargetRoot_1.return)) _a.call(dropTargetRoot_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
}
/**
 * @public
 */
export function clearMarkerOfTree(tree) {
    var e_4, _a;
    if (tree.state.dropPosition !== 0 /* empty */) {
        tree.state.dropPosition = 0 /* empty */;
    }
    if (tree.children) {
        try {
            for (var _b = __values(tree.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                clearMarkerOfTree(child);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    }
}
/**
 * @public
 */
export function getId(path, preid) {
    return preid ? preid + path.join('-') : undefined;
}
